export const CONTACT_TYPE= {contact: 'contact', registrant: 'registrant', registrantEdu: 'edu', registrantGov: 'gov', r: 'r',c:'c'}
